import { Button } from "@mui/material";
import { useMemo } from "react";
import { InternBrandStylePalette_brand$data } from "../__generated__/InternBrandStylePalette_brand.graphql";
import { ComponentColors } from "./types";

export type ButtonStyle = Pick<
  InternBrandStylePalette_brand$data["appConfig"]["buildTheme"],
  "buttonCornerRadius" | "buttonBorderThickness" | "buttonTextStyle"
>;

interface ButtonPreviewProps {
  selectedPalette: ComponentColors["button"];
  buttonStyle: ButtonStyle;
}

const ButtonPreview = ({
  selectedPalette,
  buttonStyle,
}: ButtonPreviewProps) => {
  const title = useMemo(() => {
    switch (buttonStyle.buttonTextStyle) {
      case "UPPERCASE":
        return "SAMPLE BUTTON";
      case "SENTENCE_CASE":
        return "Sample Button";
      default:
        return "Button";
    }
  }, [buttonStyle.buttonTextStyle]);

  if (!selectedPalette) return null;

  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: selectedPalette.background,
        color: selectedPalette.foreground,
        border: selectedPalette.outline
          ? `1px solid ${selectedPalette.outline}`
          : "none",
        "&:hover": {
          backgroundColor: selectedPalette.background,
          opacity: 0.9,
        },
        borderRadius: buttonStyle.buttonCornerRadius,
        borderWidth: buttonStyle.buttonBorderThickness,
      }}
    >
      {title}
    </Button>
  );
};

export default ButtonPreview;
